export default __webpack_public_path__ + "static/media/fitness.3593aa3d.png";